import React from "react";
import { useNavigate } from "react-router-dom";
import { MaqaioMark, MaqaioLockup } from "./brand/MaqaioLogo";
import { useAppBreakpoint } from "../hooks/useAppBreakpoint";

interface AppLogoProps {
  /**
   * 'auto' (lo normal) decide por ancho de pantalla. Las otras dos fuerzan
   * una versión concreta, para sitios donde el hueco manda sobre el
   * dispositivo -- hoy no las usa nadie, están para no tener que volver a
   * tocar este componente cuando haga falta.
   */
  variant?: "auto" | "mark" | "lockup";
  /** Alto en píxeles. Por defecto, el que encaja en cada cabecera. */
  height?: number;
}

/**
 * La marca de Maqaio en la cabecera, y el enlace de vuelta al inicio.
 *
 * En móvil va sólo el isotipo y en escritorio el bloque completo (ver
 * MaqaioLogo.tsx para el porqué). La decisión vive aquí dentro y no en cada
 * cabecera, que son tres y repetían el mismo ternario con los mismos números
 * copiados -- ahora las tres escriben <AppLogo /> y nada más.
 */
const AppLogo: React.FC<AppLogoProps> = ({ variant = "auto", height }) => {
  const navigate = useNavigate();
  const { isMobile } = useAppBreakpoint();

  const showMark = variant === "mark" || (variant === "auto" && isMobile);

  return (
    <div
      onClick={() => navigate("/dashboard")}
      role="button"
      aria-label="Maqaio"
      style={{
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        flexShrink: 0,
      }}
    >
      {/* Las dos cabeceras miden 64px -- el alto por defecto del Header de
          antd, que ninguna de las tres sobrescribe. Con 26 y 34 la marca
          ocupaba poco más de la mitad del alto y quedaba flotando en una
          franja blanca enorme. 34 y 50 dejan 15 y 7px de aire arriba y
          abajo: la marca manda en la cabecera en vez de perderse en ella. */}
      {showMark ? <MaqaioMark height={height ?? 34} /> : <MaqaioLockup height={height ?? 50} />}
    </div>
  );
};

export default AppLogo;
